import { Inject, Injectable } from "@angular/core";
import { CustomizedHttpService } from "../base/customized-http.service";
import { Observable } from "rxjs";


@Injectable({
  providedIn: 'root'
})
export class SessionTrackerService {

  constructor(private httpService: CustomizedHttpService, @Inject('BASE_URL') private originUrl: string) { }

  initSessionTracker(): Observable<null> {
    return this.httpService.post<any, null>(`${this.originUrl}sessionTracker/initSessionTracker`, { XRefererFor: document.referrer });
  }
  initMobileUserTracker(deviceType: string): Observable<null> {
    return this.httpService.post<any, null>(`${this.originUrl}sessionTracker/addMobileTracking`, { deviceType: deviceType });
  }
}
